import { EmailCreateValues } from './types';

export const EMAIL_CREATE_VALUES: EmailCreateValues = {
  isSupplierEmail: false,
  userId: [],
  externalEmail: null,
  memoArea: null,
  isUserSenderIncluded: false,
};
